<template>
	<input-text 
		v-model="password" 
		:type="visible ? 'text' : 'password'" 
		:label="label" 
		:disabled="disabled"
		:placeholder="placeholder"
		:errors="errors" 
		:append-icon="visible ? 'tools/design/hide' : 'tools/design/view'"
		:prepend-icon="prependIcon"
		@click:append="visible = !visible"
	></input-text>
</template>

<script>
	export default {
		props: ['label', 'errors', 'value', 'prependIcon', 'disabled', 'placeholder'],
		data(){
			return {
				visible: false,
				password: this.value
			};
		},
		watch: {
			password() {
				this.$emit('input', this.password);
			},
			value(){
				this.password = this.value;
				this.$emit('input', this.value);
			}
		}
	}
</script>